import UpdateWalletRequest from "../../../../components/@transactions/wallet/UpdateWalletRequest";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function WalletRequestUpdatePage() {

    return (
        <UpdateWalletRequest
            routeType={routeTypes.admin}
        />
    )
}       